import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import AuthContainer from '../../components/AuthContainer';
import { injectIntl } from 'react-intl';
import messages from '../../utils/commonwords';
import { signinUser } from '../../store/auth/actions';
import ForgottenPasswordForm from '../../components/ForgottenPasswordForm';

class ForgottenPassword extends Component {
  render() {
    const { intl, siteLanguage, isAuthenticated } = this.props;

    if (isAuthenticated) {
      return (
        <Redirect
          to={{
            pathname: `/${siteLanguage || 'en'}/`
          }}
        />
      );
    } else {
      return (
        <AuthContainer>
          <ForgottenPasswordForm
            intl={intl}
            messages={messages}
            siteLanguage={siteLanguage}
          />
        </AuthContainer>
      );
    }
  }
}

const mapStateToProps = state => ({
  siteLanguage: state.intl.siteLanguage,
  isAuthenticated: state.user.isAuthenticated
});

const mapDispatchToProps = dispatch => ({
  signinUser: (intl, siteLanguage, { email, password }) => {
    dispatch(signinUser(intl, siteLanguage, { email, password }));
  }
});

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ForgottenPassword)
);
